import { PropsWithChildren } from 'react';
import { Icon, FillColour } from '../Icon/Icon';
import Card from '@tempcover/bolt-ui/card';

export interface IconCardProps {
  contents?: string;
  fillColour?: FillColour;
  icon: string;
  secondaryContents?: string;
  title: string;
  twoColumns?: boolean;
  vCentre?: boolean;
}

export const IconCard = ({
  children,
  contents,
  fillColour = 'default',
  icon,
  secondaryContents,
  title,
  twoColumns,
  vCentre = false,
}: PropsWithChildren<IconCardProps>) => {
  const headingId = `${title.toLowerCase().replaceAll(' ', '-')}-heading`;

  return (
    <Card className={vCentre ? 'flex items-center' : ''}>
      <div className="gap-regular flex w-full items-center *:m-0 *:last:grow">
        <Icon name={icon} aria-labelledby={headingId} fillColour={fillColour} />
        <h3 id={headingId} className="text-dark-400 text-[18px] font-semibold">
          {title}
        </h3>
      </div>
      {contents && (
        <div className="lg:gap-regular flex flex-1 flex-col lg:flex-row">
          <div className="tc-richtext min-h-32 grow py-2" dangerouslySetInnerHTML={{ __html: contents }}></div>
          {twoColumns && secondaryContents && (
            <div className="grow" dangerouslySetInnerHTML={{ __html: secondaryContents }}></div>
          )}
        </div>
      )}
      <div>{children}</div>
    </Card>
  );
};
